
const state = { status: "", profile: {} };

const getters = {
  getProfile: state => state.profile,
  isProfileLoaded: state => !!state.profile.name
};

const actions = {
  fetchCurrentUserAction({ commit, dispatch }){
    axios.get('/api/user/me')
      .then(({data}) => {
        console.log('fetchCurrentUser', data); 
        commit('userSuccessMutation', data);
      })
      .catch((errors) => {
        console.log('fetch currenct user error',errors); 
        commit('userErrorMutation');
        // if resp is unauthorized, logout, to
        dispatch('logoutAction');
      });
  }
};

const mutations = {
  userRequestMutation(state){
    state.status = "loading";
  },
  userSuccessMutation(state, data){
    state.status = "success";
    // Vue.set(state, "profile", data);
    state.profile = data; 
  },
  userErrorMutation(state){
    state.status = "error";
  },
  authLogoutMutation(state){
    state.profile = {};
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
